import { render, staticRenderFns } from "./contextMenuInit.vue?vue&type=template&id=110b5090"
import script from "./contextMenuInit.vue?vue&type=script&lang=js"
export * from "./contextMenuInit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('110b5090')) {
      api.createRecord('110b5090', component.options)
    } else {
      api.reload('110b5090', component.options)
    }
    module.hot.accept("./contextMenuInit.vue?vue&type=template&id=110b5090", function () {
      api.rerender('110b5090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/contextMenu/contextMenuInit.vue"
export default component.exports